module.exports = __webpack_public_path__ + "static/media/SA_vertical_CA_couleur.6395b55e.png";